import { Box, Textarea, Tooltip } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeLowVision } from '@fortawesome/free-solid-svg-icons';
import { Controller } from 'react-hook-form';
import Input from './Input';
import PhoneInput from 'react-phone-input-2';
import { countries, INPUT_PROPS } from '../../../utils/constants';

export const INPUT_TYPE = {
    PASSWORD: 'password',
    INSTRUCTIONS: 'instructons',
};

const FormInput = ({
    control,
    controllName,
    label,
    variant,
    placeholder,
    hidePass,
    setHidePass,
    stepper,
    isFocus,
    icon,
    iconHandler,
    mb = '10px',
    inputProps,
    isSignUp,
    inputStyles,
    ...props
}) => {
    const selectedFlag = document.querySelector('.selected-flag');

    useEffect(() => {
        if (selectedFlag) {
            selectedFlag.style.border = 'none';
        }
    }, [selectedFlag]);

    return (
        <Box mb={mb} {...props}>
            <Controller
                control={control}
                name={controllName}
                render={({ field: { onChange, onBlur, value }, fieldState: { error } }) =>
                    variant === INPUT_TYPE.PASSWORD ? (
                        <Input
                            label={label}
                            isSignUp={isSignUp}
                            rightIcon={
                                <FontAwesomeIcon
                                    cursor='pointer'
                                    height={20}
                                    width={20}
                                    onClick={() => setHidePass((prevState) => !prevState)}
                                    icon={hidePass ? faEye : faEyeLowVision}
                                />
                            }
                            type={hidePass ? 'password' : 'text'}
                            error={error?.message}
                            placeholder={placeholder}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            inputProps={{ ...inputProps, ...inputStyles }}
                        />
                    ) : controllName === INPUT_PROPS.PHONE_NUMBER.CONTROLL_NAME ? (
                        <Tooltip {...(isSignUp && !error && { label: label })} hasArrow placement='top'>
                            <Box>
                                <PhoneInput
                                    inputStyle={{ width: '100%' }}
                                    {...(isSignUp && {
                                        inputStyle: {
                                            width: '100%',
                                            border: 'none',
                                            borderRadius: '0px',
                                            ...inputStyles,
                                        },
                                    })}
                                    onlyCountries={countries}
                                    enableSearch={true}
                                    country={'us'}
                                    inputProps={{ required: true }}
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                />
                            </Box>
                        </Tooltip>
                    ) : variant === INPUT_TYPE.INSTRUCTIONS ? (
                        <Textarea placeholder={placeholder} value={value} onChange={onChange} onBlur={onBlur} />
                    ) : (
                        <Input
                            label={label}
                            isSignUp={isSignUp}
                            rightIcon={icon}
                            autoFocus={isFocus}
                            iconHandler={iconHandler}
                            error={error?.message}
                            placeholder={placeholder}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            inputProps={{ ...inputProps, ...inputStyles }}
                        />
                    )
                }
            />
        </Box>
    );
};

export default FormInput;
